/*
  AYO size bar (sections/ayo-size-bar.liquid).
  Picking a size reads every product of the current list (collection or search, with the page's own
  filters and sort) from sections/ayo-size-index.liquid, keeps only the ones with that size in stock and
  shows them in place of the normal grid. Needs no size filter in the Search & Discovery app.
*/
(function () {
  if (customElements.get('ayo-size-bar')) return;
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const fill = (t, o) => String(t || '').replace(/\[(\w+)\]/g, (m, k) => (k in o ? o[k] : m));
  const cache = {};
  const isSizeName = (k) => /size|%d9%85%d9%82%d8%a7%d8%b3|مقاس/i.test(k);

  class AyoSizeBar extends HTMLElement {
    connectedCallback() {
      this.per = parseInt(this.dataset.per, 10) || 24;
      this.status = this.querySelector('[data-ayo-sb2-status]');
      this.clearBtn = this.querySelector('[data-ayo-sb2-clear]');
      this.size = '';
      this.addEventListener('click', (e) => {
        const b = e.target.closest('[data-ayo-sb2-size]');
        if (b) { const z = b.dataset.ayoSb2Size; if (z === this.size) this.clear(); else this.pick(z); return; }
        if (e.target.closest('[data-ayo-sb2-clear]')) { this.clear(); return; }
        if (e.target.closest('[data-ayo-sb2-more]')) this.more();
      });
      // A size in the link: ?size=38, or a size filter link like ?filter.v.option.shoe-size=38
      const q = new URLSearchParams(window.location.search);
      let start = q.get('size') || '';
      if (!start) q.forEach((v, k) => { if (!start && k.indexOf('filter.v.option.') === 0 && isSizeName(k)) start = v; });
      if (start) this.pick(start.trim(), true);
      // When the page's own filters or sort change the grid, redo the size list with the new filters.
      this.watchGrid();
    }

    get grid() { return document.getElementById('ProductGridContainer'); }

    watchGrid() {
      const g = this.grid;
      if (!g || !('MutationObserver' in window)) return;
      let t = 0;
      new MutationObserver(() => {
        if (!this.size || this.rendering) return;
        clearTimeout(t);
        t = setTimeout(() => this.pick(this.size, true), 200);
      }).observe(g, { childList: true });
    }

    query(page) {
      const q = new URLSearchParams(window.location.search);
      ['size', 'page', 'section_id'].forEach((k) => q.delete(k));
      const keep = q.toString();
      return `${window.location.pathname}?${keep ? keep + '&' : ''}section_id=ayo-size-index&page=${page}`;
    }

    async load(page) {
      const res = await fetch(this.query(page), { headers: { Accept: 'text/html' } });
      if (!res.ok) throw new Error(String(res.status));
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const s = doc.querySelector('[data-ayo-size-index]');
      if (!s) throw new Error('no data');
      return JSON.parse(s.textContent);
    }

    async all() {
      const key = this.query(0);
      if (cache[key]) return cache[key];
      const first = await this.load(1);
      const rest = [];
      for (let p = 2; p <= Math.min(first.pages || 1, 20); p += 1) rest.push(this.load(p));
      const more = await Promise.all(rest);
      const items = first.items.concat(...more.map((x) => x.items));
      cache[key] = items;
      return items;
    }

    mark() {
      this.querySelectorAll('[data-ayo-sb2-size]').forEach((b) => b.setAttribute('aria-pressed', b.dataset.ayoSb2Size === this.size ? 'true' : 'false'));
      if (this.clearBtn) this.clearBtn.hidden = !this.size;
    }

    say(text) {
      if (!this.status) return;
      this.status.textContent = text || '';
      this.status.hidden = !text;
    }

    box() {
      let r = document.getElementById('AyoSizeResults');
      if (!r) {
        r = document.createElement('div');
        r.id = 'AyoSizeResults';
        r.className = 'ayo-sb2-results';
        const g = this.grid;
        if (g && g.parentNode) g.parentNode.insertBefore(r, g);
        else this.closest('.shopify-section').insertAdjacentElement('afterend', r);
      }
      return r;
    }

    setUrl() {
      try {
        const u = new URL(window.location.href);
        if (this.size) u.searchParams.set('size', this.size); else u.searchParams.delete('size');
        window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
      } catch (e) { /* ignore */ }
    }

    async pick(size, quiet) {
      this.size = size;
      this.mark();
      this.setUrl();
      document.body.classList.add('ayo-sb2-on');
      const box = this.box();
      box.hidden = false;
      box.innerHTML = '';
      this.say(this.dataset.tLoading);
      const ticket = (this.ticket = (this.ticket || 0) + 1);
      try {
        const items = await this.all();
        if (ticket !== this.ticket) return;
        this.list = items.filter((p) => (p.s || []).some((x) => String(x).trim() === size));
        this.shown = 0;
        this.say(this.list.length ? fill(this.dataset.tShowing, { count: this.list.length, size }) : fill(this.dataset.tEmpty, { size }));
        box.innerHTML = '<div class="ayo-sb2__grid"></div><div class="ayo-sb2__foot"></div>';
        this.more();
        if (!quiet) {
          const top = this.getBoundingClientRect().top + window.scrollY - 90;
          if (window.scrollY > top) window.scrollTo({ top, behavior: 'smooth' });
        }
      } catch (e) {
        if (ticket === this.ticket) {
          this.say(this.dataset.tError);
          document.body.classList.remove('ayo-sb2-on');
          box.hidden = true;
          box.innerHTML = '';
        }
      }
    }

    card(p) {
      const badge = !p.a ? `<span class="ayo-card__badge ayo-card__badge--out">${esc(this.dataset.tSold)}</span>` : (p.o > 0 ? `<span class="ayo-card__badge">-${p.o}%</span>` : '');
      const img = p.i ? `<img src="${esc(p.i)}" alt="${esc(p.al || p.t)}" loading="lazy" width="600" height="750" class="ayo-card__img">` : '';
      const img2 = p.i2 ? `<img src="${esc(p.i2)}" alt="" loading="lazy" width="600" height="750" class="ayo-card__img ayo-card__img--2">` : '';
      const wish = this.dataset.wish === 'true' ? `<wishlist-button class="ayo-card__wish" data-id="${p.id}" data-product-handle="${esc(p.h)}" role="button" tabindex="0" aria-label="${esc(this.dataset.tWish)}"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7-4.4-7-10a4 4 0 017-2.6A4 4 0 0119 10c0 5.6-7 10-7 10z"/></svg></wishlist-button>` : '';
      return `<div class="ayo-card"><div class="ayo-card__media"><a href="${esc(p.u)}" class="ayo-card__img-link" tabindex="-1" aria-hidden="true">${img}${img2}</a>${badge}${wish}</div><a href="${esc(p.u)}" class="ayo-card__title">${esc(p.t)}</a><div class="ayo-card__price"><span>${esc(p.p)}</span>${p.c ? `<s>${esc(p.c)}</s>` : ''}</div></div>`;
    }

    more() {
      const box = document.getElementById('AyoSizeResults');
      if (!box || !this.list) return;
      const grid = box.querySelector('.ayo-sb2__grid');
      const foot = box.querySelector('.ayo-sb2__foot');
      const next = this.list.slice(this.shown, this.shown + this.per);
      this.rendering = true;
      grid.insertAdjacentHTML('beforeend', next.map((p) => this.card(p)).join(''));
      this.rendering = false;
      this.shown += next.length;
      foot.innerHTML = this.shown < this.list.length ? `<button type="button" class="ayo-sb2__more" data-ayo-sb2-more>${esc(this.dataset.tMore)} (${this.list.length - this.shown})</button>` : '';
    }

    clear() {
      this.size = '';
      this.ticket = (this.ticket || 0) + 1;
      this.mark();
      this.setUrl();
      this.say('');
      document.body.classList.remove('ayo-sb2-on');
      const box = document.getElementById('AyoSizeResults');
      if (box) { box.hidden = true; box.innerHTML = ''; }
    }
  }
  // the results box lives outside the bar, so its Show more button needs a page-level listener
  document.addEventListener('click', (e) => {
    const m = e.target.closest && e.target.closest('#AyoSizeResults [data-ayo-sb2-more]');
    if (m) { const bar = document.querySelector('ayo-size-bar'); if (bar) bar.more(); }
  });
  customElements.define('ayo-size-bar', AyoSizeBar);
})();
